document.documentElement.classList.remove('no-js');

class MobileMenu extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('[data-menu-toggle]');
    const panel = this.querySelector('[data-menu-panel]');
    if (!button || !panel) return;
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
  }
}
customElements.define('mobile-menu', MobileMenu);
